import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "invalid-delete-popup" }
const _hoisted_2 = { class: "invalid-popup" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, "Unable to Delete Builder", -1)
const _hoisted_4 = {
  key: 0,
  class: "popup-description"
}
const _hoisted_5 = {
  key: 1,
  class: "popup-description"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      ($props.invalidType === 'contact-hxp')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Your builder is too far in the registration process to delete. If you are still wanting to delete this builder please contact HXP."))
        : _createCommentVNode("", true),
      ($props.invalidType === 'cleanup')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, "You must clear all your preferences from your cart to be able to delete this builder."))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, "Close")
    ])
  ]))
}